<template>
  <div>
    <box title="نقشه">
      <div slot="top-action-view">
        <v-btn
          dark
          outlined
          v-if="canAddNewLocation"
          @click="
            () => {
              debugger
              newMarkerVisible = true;
              pnlSelectedMarkerVisible = false;
              newMarkerName='';
              personnelList=[];
              sectionList=[];

            }
          "
          >موقعیت جدید</v-btn
        >
      </div>
      <div class="pa-3">
        <v-row v-if="newMarkerVisible" class="mb-3">
          <v-col cols="6" sm="6" 
            ><v-text-field
              dense
              hide-details=""
              label="نام"
              outlined
              v-model="newMarkerName"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="pr-2"
            ><v-text-field
              dense
              hide-details=""
              label="lat"
              outlined
              v-model="centerMarker.lat"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="mt-2"
            ><v-text-field
              dense
              hide-details=""
              label="lng"
              outlined
              v-model="centerMarker.lng"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="pr-2 mt-2"
            ><v-text-field
              dense
              
              label="شعاع(متر)"
              outlined
              type="number"
              v-model="newRadius"
              :rules="radiusRules"
              :error-messages="errorMessages"
            ></v-text-field
          ></v-col>
          <v-col cols="12" class="pr-0 mt-2">
          <box v-if="showPersonel" title="انتخاب افراد">
            <v-row>
            <v-col cols="6" sm="6" class="mt-2 pr-2 pl-1"
            >
            <div class="PresentPersonel">
    <section-search-panel :accessTo="46" @search="search" style="display: none;"  />
    <box class="mt-2" :title="$t('personelList')">
     
      <div class="">
        <div >
          <section-personel-list-web
            :pagination="true"
            :list="list"
             :selectedItem="personnelList"
            
            @onClick="onClick"
          />
          <!-- <section-personel-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          /> -->
        </div>
      
      </div>
    </box>
  </div>
          </v-col>
          <v-col cols="6" sm="6" class="mt-2 pr-1  pl-2"
            >
            <div class="Present">
            <box class="mt-2" :title="$t('sectionType')">
            
              <section-type-list-panel
            :pagination="true"
            :list="sectionTypes"
            :selectedItem="sectionList"
          
            @onClick="handleClick"
          />
          
      
            </box>
          </div>
          </v-col>


        </v-row>
            </box>
          </v-col>
      
          <v-col cols="12" class="pr-0 mt-2">
            <v-row>
              <v-col class="d-none d-sm-flex"></v-col>
              <v-col class="pl-2" cols="6" sm="auto"
                ><v-btn
                  class="my-auto"
                  block
                  color="primary"
                  @click="addPersonel"
                  v-show="!showPersonel"
                  >انتخاب پرسنل
                </v-btn></v-col
              >
              <v-col class="d-flex" cols="6" sm="auto"
                ><v-btn
                  class="my-auto"
                  block
                  color="primary"
                  @click="addNewMarker"
                  >افزودن
                </v-btn></v-col
              >
              <v-col class="pr-2" cols="6" sm="auto">
                
                <v-btn block color="primary" 
                @click="
                ()=>{
                  newMarkerVisible = false;
                  EditMarker = false;
                  LastMarker.Name = '';
                  showPersonel=false;
                }
                "
                  >انصراف</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="pnlSelectedMarkerVisible" class="mb-3">
          <v-col cols="6" sm="3"
            ><v-text-field
              dense
              hide-details=""
              label="نام"
              outlined
              v-model="selectedMarker.Name"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3"
            ><v-text-field
              dense
              hide-details=""
              label="lat"
              outlined
              v-model="selectedMarker.lat"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3" class="pr-2"
            ><v-text-field
              dense
              hide-details=""
              label="lng"
              outlined
              v-model="selectedMarker.long"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3" class="pr-2"
            ><v-text-field
              dense
              label="شعاع"
              outlined
              type="number"
              v-model="selectedMarker.radius"
              :rules="radiusRules"
              :error-messages="errorMessages"
            ></v-text-field
          ></v-col>
          <v-col cols="12" class="pr-0 mt-2">
          <box v-if="showPersonel" title="انتخاب افراد">
            <v-row>
            <v-col cols="6" sm="6" class="mt-2 pr-2 pl-1"
            >
            <div class="PresentPersonel">
    <section-search-panel :accessTo="46" @search="search" style="display: none;"  />
    <box class="mt-2" :title="$t('personelList')">
     
      <div class="">
        <div >
          <section-personel-list-web
            :pagination="true"
            :list="list"
             :selectedItem="personnelList"
            
            @onClick="onClick"
          />
          <!-- <section-personel-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          /> -->
        </div>
      
      </div>
    </box>
  </div>
          </v-col>
          <v-col cols="6" sm="6" class="mt-2 pr-1  pl-2"
            >
            <div class="Present">
            <box class="mt-2" :title="$t('sectionType')">
            
              <section-type-list-panel
            :pagination="true"
            :list="sectionTypes"
            :selectedItem="sectionList"
          
            @onClick="handleClick"
          />
          
      
            </box>
          </div>
          </v-col>


        </v-row>
            </box>
          </v-col>
          <v-col cols="12" class="pr-0 mt-2">
            <v-row>
              <v-col class="d-none d-sm-flex"></v-col>
              <v-col class="pl-2" cols="6" sm="auto" 
                ><v-btn
                  class="my-auto"
                  block
                  color="primary"
                  @click="addPersonel"
                  v-show="!showPersonel"
                  >انتخاب پرسنل
                </v-btn></v-col
              >
               <v-col class="pl-2" cols="6" sm="auto"

                ><v-btn
                  block
                  color="primary"
                @click="ModifyGeoLocation(selectedMarker)"
                 
                >
                  <v-icon left>mdi-pencil</v-icon>
                  ذخیره
                </v-btn></v-col
              > 
               <v-col class="pl-2" cols="6" sm="auto">
                <v-btn
                  block
                  color="primary"
                  @click="DeleteGeoLocation(selectedMarker)"
                >
                  <v-icon left>mdi-delete</v-icon>

                  حذف</v-btn
                ></v-col
                
              >
               <v-col class="pl-2" cols="6" sm="auto">
                
                <v-btn block color="primary" 
                @click="
                ()=>{
                 
                 
                 
                newMarkerVisible = false;
                pnlSelectedMarkerVisible=false;
                EditMarker = false;
                LastMarker.Name = '';
                showPersonel=false;
                this.GetGeoLocation();
                  
                }
                "
                  >انصراف</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="h-100" style="height: 85vh">
          <v-col>
            <l-map
            id="mapp"
              :options="mapOptions"
              style="z-index: 0"
              :zoom="zoom"
              :center="center"
              @update:center="centerUpdate"
              @click="clickEditMarker"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-control-attribution
                :position="'bottomright'"
                :prefix="'www.elmosanat.com'"
              />
              <div v-if="newMarkerVisible">
                <l-marker draggable :lat-lng.sync="centerMarker">
                  <l-icon
                    class="new-marker"
                    :icon-size="[50, 50]"
                    :icon-url="require('@/assets/icons/pin-location.svg')"
                  ></l-icon>
                </l-marker>
                <l-circle :lat-lng="centerMarker" :radius="newRadius" />
              </div>
              <div v-if="markerList.length > 0">
                <div v-for="(marker, i) in markerList" :key="i">
                  <l-marker 
                  :lat-lng="getMarkerLatLng(marker)"
                 
                    @click="onClickMarker(marker)" 
                            
                  
                  ></l-marker>
                  <l-circle
                    :lat-lng="getMarkerLatLng(marker)"
                    :radius="marker.radius"
                  />
                </div>
              </div>
            </l-map>
          </v-col>
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LControlAttribution,
  LCircle,
  LIcon,
} from "vue2-leaflet";
import ResultType from "../../../model/ResultType";
import EosToastType from "../../../model/EosToastType";
//import SectionPersonelListMob from "../../../components/personelOperationReport/sectionPersonelList/sectionPersonelListMob.vue";
import SectionPersonelListWeb from "../../../components/personelOperationReport/sectionPersonelList/sectionPersonelListWeb2.vue";
import SectionSearchPanel from "../../../components/personelOperationReport/SectionSearchPanel.vue";
import SectionTypeListPanel from "../../../components/personelOperationReport/SectionTypeListPanel.vue";
//import EmptyList from "../../../components/widget/EmptyList.vue";
import StateList from "../../../model/StateList";
import EosUtils from "../../../utils/EosUtils";
//import TextUtils from "../../../utils/TextUtils";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
    LCircle,
    LIcon,
    SectionSearchPanel,
    //EmptyList,
    SectionPersonelListWeb,
   // SectionPersonelListMob,
    SectionTypeListPanel
  },
  data() {
    return {
      map :document.getElementById('mapp'),
      zoom: 12,
      center: L.latLng(35.687656, 51.388546),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      marker: L.latLng(35.687656, 51.388546),
      attribution: "",
      mapOptions: {
        zoomControl: true,
        attributionControl: false,
        zoomSnap: true,
      },
      centerMarker: "",
      newLat: "",
      newLng: "",
      newRadius: 100,
      newMarkerName: "",
      newMarkerVisible: false,
      EditMarker:false,
      LastMarker:{},
      pnlSelectedMarkerVisible: false,
      showPersonel:false,
      oldSelectedMarker: {},
      selectedMarker: {},
      markerList: [],
      canAddNewLocation: false,
      list: [],
      searchParams: null,
      stateList: null,
      visiblePrint: false,
      sectionCode: "",
      sectionTypes: [],
      //personnelList:["1230","5004"],
      //sectionList:["02","0203"],
      personnelList:[],
      sectionList:[],
      headers: [
        {
          text: this.$t("card-no"),
          value: "Code",
        },
        {
          text: this.$t("name"),
          value: "Name",
        },
      
        
      ],
      errorMessages: [], // Array to store error messages
      radiusRules: [
      (value) => !!value || "فیلد شعاع الزامی است.",
      (value) => (value >= 0) || "شعاع نمی‌تواند منفی باشد.",
      (value) => (value <= 200) || "شعاع باید کمتر یا مساوی ۲۰۰ متر باشد.",
      ],
    };
  },
  mounted() {
    this.centerMarker = this.center;
    this.GetGeoLocation();
   
  
  },
  watch:{
    newRadius(value) {
      // Validate the input whenever it changes
      this.errorMessages = this.radiusRules
        .map((rule) => rule(value)) // Apply each rule
        .filter((message) => typeof message === "string"); // Filter out error messages
    },
   // selectedMarker() {
   //  this.marker=L.latLng(this.selectedMarker.long, this.selectedMarker.lat);
   //  this.marker.radius=this.selectedMarker.radius;
   // }
  },
  methods: {
   
    latLng(lat, lng) {
      return L.latLng(lat, lng);
    },
    centerUpdate(center) {
    
      this.center = center;
      this.centerMarker = center;
     this.pnlSelectedMarkerVisible = false;
    },
    getMarkerLatLng(marker) {

   //  this.selectedMarker.radius=marker.radius;
      return L.latLng(marker.lat, marker.long);
    },
    handleClick(value) {
     
      this.$emit("onClick", value);
      
    },
    cancel(){
debugger;

this.selectedMarker=this.oldSelectedMarker;
this.newMarkerVisible = false;
                // pnlSelectedMarkerVisible=false;
                // EditMarker = false;
                // LastMarker.Name = '';
                 this.showPersonel=false;
                 this.GetGeoLocation();
    },
     getSectionTypes() {
     
        this.$store.dispatch("sections/GetAllSections").then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.sectionTypes.forEach((element) => {
     
      const data = this.sectionTypes.filter((item) => (this.sectionList.includes(item.Code.trim())));
     var num=data.find(item => item.Code.trim()==element.Code.trim());
     if(num){
      element.select = true;
     }else{
      element.select = false;
     }
         

        });
          }
        });
      
    
    },
    GetGeoLocation() {
      this.$store.dispatch("geolocation/GetGeoLocation").then((result) => {
        console.log(result);
        if (result.type == ResultType.success) {
          debugger;
          this.markerList = result.data;
          var GeoFenceCount = this.$store.state.lock.lockData.GeoFenceCount;
          if ((GeoFenceCount && Number(GeoFenceCount)) > this.markerList.length) {
            this.canAddNewLocation = true;
          } else {
            this.canAddNewLocation = false;
          }
        }
      });
    },
    getNewMarkerIcon() {
      /*var item = {
        color: "#000",
        strokeColor: "#00000000",
        circleColor: "#000",
      };*/
      return L.divIcon({
        className: "my-custom-pin",
      });
    },
    addPersonel(){

      this.showPersonel=true;
      this.getSectionTypes();
    },
    addNewMarker() {
    
      var  codelist = this.sectionTypes.filter((item) => (item.select==true));
      var code=codelist.map(o=>o.Code.trim());
      var pernolist = this.list.filter((item) => (item.select==true));
     var perno=pernolist.map(o=>o.PERNO.trim());
      var GeoFenceCount = this.$store.state.lock.lockData.GeoFenceCount;
      if (GeoFenceCount && Number(GeoFenceCount) > this.markerList.length) {
        this.canAddNewLocation = true;
      } else {
        this.canAddNewLocation = false;
      }

      if (!this.canAddNewLocation) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "بیشتر از حد مجاز نمیتوانید موقعیت جدید ثبت نمایید",
        });
        return;
      }
      
      if (this.EditMarker ) {
        
        if( this.newMarkerName==''){
          this.newMarkerName=this.LastMarker.Name;
        }
        else{
          this.LastMarker.Name=this.newMarkerName;
        }
      }

      if (!this.newMarkerName) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "یک نام برای موقعیت مورد نظر وارد نمایید",
        });
        return;
      }

     
      this.$store
        .dispatch("geolocation/AddGeoLocation", {
          data: {
            lat: this.centerMarker.lat,
            lng: this.centerMarker.lng,
            radius: this.newRadius,
            name: this.EditMarker?this.LastMarker.Name:this.newMarkerName,
            personnelList:perno,
            sectionList:code
           
          },
        })
        .then((result) => {
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.newMarkerVisible = false;
           // if (this.EditMarker) {  
           //   this.DeleteGeoLocation(this.LastMarker);
           // }
            if (!this.EditMarker) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت جدید با موفقیت اضافه شد",
            });
          }else{
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت انتخاب شده با موفقیت ویرایش شد",
            });
            
          }
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result?.message,
            });
          }
        });
    },
    onClickMarker(marker) {
      //console.log(marker);
      debugger
      this.personnelList=[];
      this.sectionList=[];
      this.showPersonel=false;
      this.LastMarker=marker;
      this.selectedMarker = marker;
      this.centerMarker=marker;
     this.pnlSelectedMarkerVisible = true;
     this.newMarkerVisible = false;
      this.GetGeoLocationAllowedPersonels(marker);
      this.GetGeoLocationAllowedSections(marker);
    },
    clickEditMarker(latlng){
 debugger;
      if(this.selectedMarker){
        debugger;
      
        this.oldSelectedMarker={...this.selectedMarker} ;
        this.selectedMarker.lat=latlng.latlng.lat;
     this.selectedMarker.long=latlng.latlng.lng;

      }
      
    },
   
    DeleteGeoLocation(selectedMarker) {
      //console.log(selectedMarker);
      this.$store
        .dispatch("geolocation/DeleteGeoLocation", {
          params: {
            id: selectedMarker.id,
          },
        })
        .then((result) => {
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            if (!this.EditMarker) {
              this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت انتخاب شده با موفقیت حذف شد",
            });
            }
            else {
              this.EditMarker = false;
              this.LastMarker.Name = "";
            }

           
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: "خطا در انجام عملیات",
            });
          }
        });
    },
    GetGeoLocationAllowedPersonels(selectedMarker)
    {
     
 
      this.$store
        .dispatch("geolocation/GetGeoLocationAllowedPersonels", {
          params: {
            id: selectedMarker.id,
          },
        })
        .then((result) => {
        
         // console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.personnelList=result.data.map(o=>o.Perno);
          } else {
            this.personnelList=[];
            //this.$EosToast.show({
            //  type: EosToastType.error,
            //  msg: "خطا در انجام عملیات",
            //});
          }
        });
    },
    GetGeoLocationAllowedSections(selectedMarker)
    {
      
      this.$store
        .dispatch("geolocation/GetGeoLocationAllowedSections", {
          params: {
            id: selectedMarker.id,
          },
        })
        .then((result) => {
          debugger;
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.sectionList=result.data.map(o=>o.Section);
          } else {
            this.sectionList=[];
            //this.$EosToast.show({
            //  type: EosToastType.error,
            //  msg: "خطا در انجام عملیات",
            //});
          }
        });
    },

    ModifyGeoLocation(selectedMarker) {
     
      var  codelist = this.sectionTypes.filter((item) => (item.select==true));
      var code=codelist.map(o=>o.Code.trim());
      var pernolist = this.list.filter((item) => (item.select==true));
     var perno=pernolist.map(o=>o.PERNO.trim());
      //console.log(selectedMarker);
      this.$store
        .dispatch("geolocation/ModifyGeoLocation", {
          data: {
            id: selectedMarker.id,
            name:selectedMarker.Name,
            lat: selectedMarker.lat,
            lng: selectedMarker.long,
            radius: selectedMarker.radius,
            personnelList:perno,
            sectionList:code
          },
        })
        .then((result) => {
         // console.log(result);
          if (result.type == ResultType.success && result.data) {
            //this.newMarkerVisible = false;
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت جدید با موفقیت ویرایش شد",
            });
            this.newMarkerVisible = false;
            this.EditMarker = false;
            this.LastMarker.Name = '';
            this.showPersonel=false;
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result?.message,
            });
          }
        });
    },
  toEnglishDigits(str) {

// convert persian digits [۰۱۲۳۴۵۶۷۸۹]
var e = '۰'.charCodeAt(0);
str = str.replace(/[۰-۹]/g, function(t) {
    return t.charCodeAt(0) - e;
});

// convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
e = '٠'.charCodeAt(0);
str = str.replace(/[٠-٩]/g, function(t) {
    return t.charCodeAt(0) - e;
});
return str;
},
    search(searchParams) {
      
      this.list = [];
      this.stateList = StateList.loading();
      this.sectionCode = searchParams.sectionCode;

      this.searchParams = searchParams;
      var params = searchParams;
      this.$store.dispatch("GetSectionPersons", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.stateList = null;
          this.list = result.data.Table1;
          this.list = this.list.sort((a, b) => a.PERNO >= b.PERNO);
          this.list.forEach((element) => {
      
      element.PERNO=this.toEnglishDigits(element.PERNO).toString();
      const data = this.list.filter((item) => (this.personnelList.includes(item.PERNO.trim())));
     var num=data.find(item => item.PERNO.trim()==element.PERNO.trim());
     if(num){
      element.select = true;
     }else{
      element.select = false;
     }
    });

          this.checkVisiblePrint();
        } else {
          this.stateList = StateList.error(result.error);
        }
      });
    },
    onClick(item) {
   
      //debugger
      console.log(item);
      //this.personnelList.push(item.PERNO);
  //   if (EosUtils.isWebKartAdmin()) {
  //     //go to personel profile
  //     var params = {
  //       pid: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
  //       section: this.searchParams.sectionCode,
  //     };
  //     this.$router.push({ name: "personelProfile", query: params });
  //   } else {
  //     //debugger
  //     var params2 = {
  //       pid: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
  //       section: this.searchParams.sectionCode,
  //       // canchange
  //       ch:"1",   
  //      
  //     };
  //     //debugger
  //     localStorage.setItem("pidSetPass", params2.pid)
  //     this.$router.push({ name: "profile", query: params2 });
  //     // this.$router.push({ name: "personelProfile", query: params2 });
  //     /*
  //       if (Sections.CanAccessPersonProfile(PersonnelNo, ddlSections.SelectedItem.Value))
  //                     Response.Redirect("default.aspx?PID=" + perno + "&SC=" + section);
  //      */
  //   }
    },
    checkVisiblePrint() {
      // //debugger
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      }
    },
  
  },
};
</script>

<style>
.new-marker {
  color: rgb(208, 255, 0);
}
</style>